import { AxiosResponse } from "axios";
import ApiProcedureRequest from "src/models/api.procedure.request";
import ApiProcedureResponse from "src/models/api.procedure.response";
import { ApiRequest } from "src/models/api.request";
import { http } from "./http";
import SnackbarUtils from "src/utils/SnackbarUtils";

export class ApiResponse<T> {
	constructor() {
		this.errorMessage = null;
		this.responseCode = null;
		this.totalRecords = 0;
	}
	errorMessage?: string;
	responseCode?: number;
	version?: string;
	data?: T; // T[] olmalı mı?
	totalRecords?: number; // Change to BaseResponseData -> ModelBase<T> ???
}

class apiResponse<T> extends ApiResponse<T> {
	constructor() {
		super();
		this.errorMessages = [];
	}
	errorMessages: Array<string>;
}
interface IApiService<T> {
	getOne(id: string | number): Promise<ApiResponse<T>>
	//getList(): Promise<ApiResponse<Array<T>>>
	create(data: T): Promise<ApiResponse<T>>
	update(data: T): Promise<ApiResponse<T>>
	//delete(data: T): void
	delete(id: string | number, actionName?: string): Promise<ApiResponse<boolean>>
	find(whereFilters: ApiRequest<T>): Promise<ApiResponse<Array<T>>>
	post<R>(actionName: string, request: any): Promise<ApiResponse<R>>
	get<R>(actionName: string, request: any): Promise<ApiResponse<Array<R>>>
	put<R>(actionName: string, request: any): Promise<ApiResponse<R>>
}

export class ApiService<T> implements IApiService<T> {
	constructor(controllerName: string) {
		this.controllerName = controllerName;
	}

	//private entitySlug: string;
	protected controllerName: string;
	private aAxiosResponseToApiResponse<R>(response: AxiosResponse<apiResponse<R>>): ApiResponse<R> {
		if ((response as any)?.message) {
			let responseCode = (response as any).status;
			if (!responseCode)
				responseCode = 500
			SnackbarUtils.error((response as any).message)
			return {
				errorMessage: (response as any).message,
				responseCode
			}
		}
		if (response.status != 200) {
			SnackbarUtils.error(response.statusText)
			return {
				errorMessage: response.statusText,
				responseCode: response.status,
			}
		}
		const errorMessage = response?.data.errorMessages && response?.data.errorMessages.length > 0 ?
		response?.data.errorMessages[0]
		: null;
		if (errorMessage)
			SnackbarUtils.error(errorMessage);
		return {
			data: response?.data.data,
			errorMessage: errorMessage,
			responseCode: response?.data.responseCode,
			totalRecords: response?.data.totalRecords,
			version: response?.data.version,
		};
	}
	getOne = async (id: string | number): Promise<ApiResponse<T>> => {
		try {
			// const request = await fetch(process.env.BE_HOST + this.entitySlug + '/' + id);
			// const response = await request.json();
			const response = await http.get<T, AxiosResponse<apiResponse<T>>>(this.controllerName + '/' + id);
			return this.aAxiosResponseToApiResponse<T>(response);
		}
		catch (error) {
			return this.aAxiosResponseToApiResponse<T>(error);
		}
	};

	create = async (data: T): Promise<ApiResponse<T>> => {
		try {
			//create = async (body: Omit<T, 'id' | 'created' | 'updated'>): Promise<ApiResponse<T>> => {
			// const request = await fetch(process.env.BE_HOST + this.entitySlug, {
			// 	method: 'POST',
			// 	body: JSON.stringify(body)
			// });
			// const response = await request.json();
			const response = await http.post<T, AxiosResponse<apiResponse<T>>>(this.controllerName, data);
			return this.aAxiosResponseToApiResponse<T>(response);
		}
		catch (error) {
			return this.aAxiosResponseToApiResponse<T>(error);
		}
	};

	update = async (
		data: T
		//body: Omit<Partial<T>, 'id' | 'created' | 'updated'>
	): Promise<ApiResponse<T>> => {
		try {
			// const request = await fetch(process.env.BE_HOST + this.entitySlug + '/' + body.id, {
			// 	method: 'PATCH',
			// 	body: JSON.stringify(body)
			// });
			// const response = await request.json();
			const response = await http.put<T, AxiosResponse<apiResponse<T>>>(this.controllerName, data);
			return this.aAxiosResponseToApiResponse<T>(response);
		}
		catch (error) {
			return this.aAxiosResponseToApiResponse<T>(error);
		}
	};

	delete = async (id: string | number, actionName: string = ""): Promise<ApiResponse<boolean>> => {
		try {
			// const request = await fetch(process.env.BE_HOST + this.entitySlug + '/' + id, {
			// 	method: 'DELETE'
			// });
			// const response = await request.json();

			const response = await http.delete<boolean, AxiosResponse<apiResponse<boolean>>>
				(this.controllerName + '/' + (actionName ? actionName + "/" : "") + id);
			// const { data: request }: { data: any } = await http.put<T>(this.entitySlug, data);
			// if (response?.data.errorMessages && response?.data.errorMessages.length > 0)
			// 	throw new Error(response?.data.errorMessages[0]);

			return this.aAxiosResponseToApiResponse<boolean>(response);
		}
		catch (error) {
			return this.aAxiosResponseToApiResponse<boolean>(error);
		}
	};

	find = async (whereFilters: ApiRequest<T>): Promise<ApiResponse<Array<T>>> => {
		try {
			// Note: Since data comes from backend not actually ITest[] directly, we must call it like: http.post<any, AxiosResponse<any>>
			// not http.post<any, AxiosResponse<ITest>>
			//return http.post<any, AxiosResponse<any>>(this.entitySlug + '/find', whereFilters);

			const response = await http.post<ApiRequest<T>, AxiosResponse<apiResponse<Array<T>>>>(this.controllerName + '/find', whereFilters);
			return this.aAxiosResponseToApiResponse<Array<T>>(response);
		}
		catch (error) {
			return this.aAxiosResponseToApiResponse<Array<T>>(error);
		}
	}

	post = async <R>(actionName: string, request: any): Promise<ApiResponse<R>> => {
		try {
			const response = await http.post<ApiRequest<T>, AxiosResponse<apiResponse<R>>>(this.controllerName + "/" + actionName, request);
			return this.aAxiosResponseToApiResponse<R>(response);
		}
		catch (error) {
			return this.aAxiosResponseToApiResponse<R>(error);
		}
	}

	get = async <R>(actionName: string, request: any = null): Promise<ApiResponse<R>> => {
		try {
			const response = await http.get<any, AxiosResponse<apiResponse<R>>>(this.controllerName + "/" + actionName, { params: request });
			return this.aAxiosResponseToApiResponse<R>(response);
		}
		catch (error) {
			return this.aAxiosResponseToApiResponse<R>(error);
		}
	}
	put = async <R>(actionName: string, request: any): Promise<ApiResponse<R>> => {
		try {
			const response = await http.put<ApiRequest<T>, AxiosResponse<apiResponse<R>>>(this.controllerName + "/" + actionName, request);
			return this.aAxiosResponseToApiResponse<R>(response);
		}
		catch (error) {
			return this.aAxiosResponseToApiResponse<R>(error);
		}
	}
	file = async (actionName: string, request: any): Promise<ApiResponse<Blob>> => {
		var res = new ApiResponse<Blob>();
		try {
			var resFile = await http.post<ApiRequest<T>, AxiosResponse<Blob>>(this.controllerName + "/" + actionName, request,
				{
					responseType: "blob"
				});
			if (resFile.data.type?.indexOf("application/json") > -1) {
				var json = await resFile.data.text()

				var apiRes = JSON.parse(json);
				res = this.aAxiosResponseToApiResponse({
					...resFile,
					data: apiRes
				});
				return res;
			}
			res.data = resFile.data;
			res.responseCode = 200;
			return res;
		}
		catch (error) {
			return this.aAxiosResponseToApiResponse(error);
		}
	}
	execute = async (name: string, request: Array<ApiProcedureRequest>): Promise<ApiResponse<Array<ApiProcedureResponse>>> => {
		try {
			const response = await http.post<Array<ApiProcedureRequest>, AxiosResponse<apiResponse<Array<ApiProcedureResponse>>>>("procedure/execute/" + name, request);
			return this.aAxiosResponseToApiResponse<Array<ApiProcedureResponse>>(response);
		}
		catch (error) {
			return this.aAxiosResponseToApiResponse<Array<ApiProcedureResponse>>(error);
		}
	}
};

